import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  NgZone,
  OnDestroy,
  OnInit, ViewChild,
} from '@angular/core';
import {ConferenceService} from '../../service/conference.service';
import {UserService} from '../../../../services/user.service';
import ZoomMtgEmbedded, {SuspensionViewType} from '@zoom/meetingsdk/embedded';
import {ZoomCredentials} from '../../models/zoom.model';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-zoom',
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.scss'],
})

export class ZoomComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() speakerVideoType: string = 'speaker';

  @Input() set resize(value: any) {
    setTimeout(() => {
      if (this.videoCanvas) {
        this.setShareScreenSize();
        this.setSpeakerVideoSize();
      }
    }, 100);
  };

  @Input() set isInteractionActive(status: boolean) {
    this.interactionMode = status;
    this.initSpeakerMode();
  }

  @Input() credentials: ZoomCredentials = null;
  @Input() speakerVideoElement: HTMLElement = null;
  @Input() chatElement: HTMLElement = null;

  @ViewChild('shareScreen', {static: false}) shareScreenRef!: ElementRef;
  @ViewChild('zoomRoot', {static: false}) zoomRootRef!: ElementRef;

  role = 0;
  // registrantToken = '';
  // zakToken = '';
  // leaveUrl = 'http://localhost:4200';

  zoomClient = null;

  todoList = [
    'findVideoCanvas',
    'findShareCanvas',
    // 'monitorShareMode',
    // 'monitorVideoCanvas',
    // 'monitorShareCanvas',
    // 'moveVideoCanvas',
    // 'moveShareCanvas',
    // 'activateChatPanel',
    // 'listenMeetingDisconnected',
  ];

  speakerMode = null;
  shareMode = null;
  interactionMode = null;

  chatStyleSheet = null;

  videoCanvas = null;
  videoOverlay = null;
  shareCanvas = null;

  interval = null;

  constructor(
    private ngZone: NgZone,
    private conferenceService: ConferenceService,
    public userService: UserService,
  ) {
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.joinConference();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setShareScreenSize();
    this.setSpeakerVideoSize();
  }

  private getSpeakerVideoElementWidth() {
    if (this.speakerVideoElement) {
      return this.speakerVideoElement.offsetWidth;
    }
    return 0;
  }

  private setSpeakerVideoSize() {
    if (this.speakerVideoElement) {
      if (this.speakerVideoType === 'ribbon') {
        if (this.shareScreenRef && !this.interactionMode) {
          if (this.getShareScreenSizeWidth()) {
            this.speakerVideoElement.style.height = 'calc(' + this.getShareScreenSizeWidth() * 0.6 + 'px - 2rem)';
          }
        } else {
          if (this.getSpeakerVideoElementWidth()) {
            this.speakerVideoElement.style.height = this.getSpeakerVideoElementWidth() * 0.6 + 'px';
          }
        }
      } else {
        if (this.getSpeakerVideoElementWidth()) {
          this.speakerVideoElement.style.height = this.getSpeakerVideoElementWidth() * 0.6 + 'px';
        }
      }
      return;
    }
  }

  private getShareScreenSizeWidth() {
    if (this.shareScreenRef) {
      return this.shareScreenRef.nativeElement.offsetWidth;
    }
    return 0;
  }

  private setShareScreenSize() {
    if (this.shareScreenRef) {
      this.shareScreenRef.nativeElement.style.height = this.getShareScreenSizeWidth() * 0.6 + 'px';
    }
  }

  private joinConference() {
    this.conferenceService.generateZoomAuth(this.credentials.meetingNumber, this.role)
      .then(token => {
        if (token) {
          this.startMeeting(token);
        }
      });
  }

  private startMeeting(signature) {
    // document.getElementById('zmmtg-root').style.display = 'block'

    this.ngZone.runOutsideAngular(() => {
      this.zoomClient = ZoomMtgEmbedded.createClient();

      this.zoomClient.init({
        debug: false,
        zoomAppRoot: this.zoomRootRef.nativeElement,
        language: 'en-US',
        patchJsMedia: true,
        leaveOnPageUnload: true,
        customize: {
          video: {
            popper: {
              disableDraggable: false,
            },
            isResizable: false,
            viewSizes: {
              ribbon: {
                width: 316,
                height: 135
              },
              default: {
                width: 316,
                height: 135
              }
            },
            defaultViewType: SuspensionViewType.Gallery,
            /** Minimized = 'minimized',
             Speaker = 'speaker',
             Ribbon = 'ribbon',
             Gallery = 'gallery',
             Active = 'active' */
          },
          chat: {
            popper: {
              disableDraggable: true,
              anchorReference: 'anchorEl',
              anchorElement: this.chatElement,
              placement: 'bottom-end' //'bottom-end'
            }
          },
        }
      }).then((res) => {
        console.log('client.init', res);
        this.zoomClient.join({
          signature: signature,
          sdkKey: this.credentials.sdkKey,
          meetingNumber: this.credentials.meetingNumber,
          password: this.credentials.passcode,
          userName: this.credentials.userName,
          userEmail: this.credentials.userEmail,
          // registrantToken: this.registrantToken,
          // zakToken: this.zakToken,
        }).then((res) => {
          console.log('client.join', res);

          this.interval = setInterval(() => {
            this.runTasksFromTodoList();
          }, environment.production ? 1000 : 5000);

        }).catch((error) => {
          console.log('client.join.catch', error);
        });
      });
    });
  }

  private runTasksFromTodoList() {
    if (this.todoList.length === 0) {
      return;
    }

    this.todoList.forEach(task => {
      if (this[task]) {
        this.ngZone.run(() => {
          console.log('Running task', task);
          this[task]();
        });
      }
    });
  }

  private registerTask(task: string) {
    if (!this.todoList.includes(task)) {
      this.todoList.push(task);
    }
  }

  private completeTask(task) {
    this.todoList = this.todoList.filter(item => item !== task);
  }

  private monitorShareMode() {
    const shareModeElement = this.zoomRootRef.nativeElement.querySelector('div.css-ip80nc');

    if (this.shareMode === null || !!shareModeElement !== this.shareMode) {
      this.shareMode = !!shareModeElement;
      console.log('Share mode has been changed to', this.shareMode);
      this.initSpeakerMode();
    }
  }

  private initSpeakerMode() {
    if (this.speakerMode == null || this.speakerMode !== (this.interactionMode || this.shareMode)) {
      this.speakerMode = this.interactionMode || this.shareMode;
      if (this.videoCanvas && this.videoOverlay) {
        this.registerTask('moveVideoCanvas');
      }
    }
  }

  private findVideoCanvas() {
    const canvas = this.zoomRootRef.nativeElement.querySelector('canvas[aria-label="Participant Videos"]');
    const overlay = this.zoomRootRef.nativeElement.querySelector('.css-vv0cdr');
    if (canvas && overlay) {
      this.videoCanvas = canvas;
      this.videoOverlay = overlay;
      this.completeTask('findVideoCanvas');
      this.registerTask('moveVideoCanvas');
    }
  }

  private monitorVideoCanvas() {
    const canvas = this.zoomRootRef.nativeElement.querySelector('canvas[aria-label="Participant Videos"]');
    const overlay = this.zoomRootRef.nativeElement.querySelector('.css-vv0cdr');
    if (canvas && overlay && this.videoCanvas && this.videoOverlay) {
      this.videoCanvas.remove();
      this.videoOverlay.remove();

      this.videoCanvas = canvas;
      this.videoOverlay = overlay;
      this.completeTask('monitorShareCanvas');
      this.registerTask('moveVideoCanvas');
    }
  }

  private listenMeetingDisconnected() {
    const meeting = this.zoomRootRef.nativeElement.querySelector('div[aria-label="Zoom Web SDK Widget"]');
    if (this.videoCanvas && !meeting) {
      console.log('Meeting has been disconnected');

      this.videoCanvas.remove();
      this.videoOverlay.remove();

      if (this.shareCanvas) {
        this.shareCanvas.remove();
      }

      this.shareScreenRef.nativeElement.style.height = '0px';
      this.shareScreenRef.nativeElement.style.display = 'none';
      this.zoomRootRef.nativeElement.style.display = 'none';

      ZoomMtgEmbedded.destroyClient();
      clearInterval(this.interval);

      this.completeTask('listenMeetingDisconnected');
    }
  }

  private moveVideoCanvas() {
    if (this.videoCanvas && this.videoOverlay) {
      console.log('Moving video canvas...');
      if (this.speakerMode) {
        console.log('Share mode is active');
        this.speakerVideoElement.appendChild(this.videoCanvas);
        this.speakerVideoElement.appendChild(this.videoOverlay);
        if (this.shareCanvas) {
          this.shareCanvas.style.display = 'inline';
        }
      } else {
        console.log('Share mode is not active');
        this.shareScreenRef.nativeElement.appendChild(this.videoCanvas);
        this.shareScreenRef.nativeElement.appendChild(this.videoOverlay);
        if (this.shareCanvas) {
          this.shareCanvas.style.display = 'none';
        }
      }
      this.setSpeakerVideoSize();
      this.completeTask('moveVideoCanvas');
      this.registerTask('monitorVideoCanvas');
      this.registerTask('monitorShareMode');
    }
  }

  private findShareCanvas() {
    const canvas = this.zoomRootRef.nativeElement.querySelector('canvas[aria-label="Screen share"]');
    if (canvas) {
      this.shareCanvas = canvas;
      this.completeTask('findShareCanvas');
      this.registerTask('moveShareCanvas');
    }
  }

  private monitorShareCanvas() {
    const canvas = this.zoomRootRef.nativeElement.querySelector('canvas[aria-label="Screen share"]');
    if (canvas && this.shareCanvas) {
      this.shareCanvas.remove();

      this.shareCanvas = canvas;
      this.completeTask('monitorShareCanvas');
      this.registerTask('moveShareCanvas');
    }
  }

  private moveShareCanvas() {
    if (this.shareCanvas) {
      this.setShareScreenSize();
      this.shareScreenRef.nativeElement.appendChild(this.shareCanvas);
      this.completeTask('moveShareCanvas');
      this.registerTask('monitorShareCanvas');
      this.registerTask('monitorShareMode');
    }
  }

  private activateChatPanel() {
    const chatPanel = document.querySelector('div[aria-label="Chat"]');
    if (chatPanel) {
      this.completeTask('activateChatPanel');
      return;
    }

    const chatButton = this.zoomRootRef.nativeElement.querySelector('button[aria-label="Chat"]');
    if (chatButton) {
      chatButton.click();
      this.completeTask('activateChatPanel');
      return;
    }

    const moreButton = this.zoomRootRef.nativeElement.querySelector('button[aria-label="More"]');
    if (moreButton) {
      moreButton.click();

      setTimeout(() => {
        const menuItems = document.querySelectorAll('[role="menuitem"]');
        let chatButton = null;

        menuItems.forEach(item => {
          if (item.textContent.trim() === 'Chat') {
            chatButton = item;
          }
        });

        if (chatButton) {
          chatButton.click();
        }

        this.completeTask('activateChatPanel');
      }, 100);
      return;
    }
  }

  private closeChatPanel() {
    const chatPanel = document.querySelector('div[aria-label="Chat"]');
    if (chatPanel) {
      const closeButton = chatPanel.querySelector<HTMLButtonElement>('button[aria-label="Close"]');
      if (closeButton) {
        closeButton.click();
      }
      return;
    }
  }

  ionViewWillLeave() {
    this.closeChatPanel();
  }

  ngOnDestroy() {
    if (this.zoomClient) {
      ZoomMtgEmbedded.destroyClient();
    }
    clearInterval(this.interval);
  }
}
